import { call, put } from 'redux-saga/effects';

import { fetchEntities, fetchInstruments, fetchArtifacts } from 'services';
import {
  SEARCH_ENTITIES_SUCCESS,
  SEARCH_ENTITIES_ERROR,
  SEARCH_INSTRUMENTS_SUCCESS,
  SEARCH_INSTRUMENTS_ERROR,
  SEARCH_RATING_NEWS_SUCCESS,
  SEARCH_RATING_NEWS_ERROR,
  SEARCH_RESEARCH_SUCCESS,
  SEARCH_RESEARCH_ERROR,
} from './searchResultActions';

export function* searchEntitiesSaga({ payload }) {
  const { query, limit, page, sort, filter, ratingType, userId } = payload;

  const response = yield call(
    fetchEntities,
    { query, limit, page, sort, filter, userId },
    ratingType,
  );

  yield put({
    type: !response.error ? SEARCH_ENTITIES_SUCCESS : SEARCH_ENTITIES_ERROR,
    payload: { response, ratingType },
  });
}

export function* searchInstrumentsSaga({ payload }) {
  const { query, limit, page, sort, filter } = payload;

  try {
    const response = yield call(fetchInstruments, { query, limit, page, sort, filter });
    yield put({ type: SEARCH_INSTRUMENTS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: SEARCH_INSTRUMENTS_ERROR, payload: response });
    throw new Error(response);
  }
}

export function* searchRatingNewsSaga({ payload }) {
  try {
    const response = yield call(fetchArtifacts, payload);
    yield put({ type: SEARCH_RATING_NEWS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: SEARCH_RATING_NEWS_ERROR, payload: response });
    throw new Error(response);
  }
}

export function* searchResearchSaga({ payload }) {
  try {
    const response = yield call(fetchArtifacts, payload);
    yield put({ type: SEARCH_RESEARCH_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: SEARCH_RESEARCH_ERROR, payload: response });
    throw new Error(response);
  }
}
